import type { ReactNode } from 'react'
import { DetailsCard, TextArea } from './DetailsCard'

/** Copy: the main copy the piece carries, and the copy files it came from. */
export function CopyCard({
	mainCopy,
	onChange,
	onCopy,
	isRequired,
	requiresAction,
	files,
}: {
	mainCopy: string
	/** Absent when the copy is read-only. */
	onChange?: (value: string) => void
	onCopy: (value: string) => void
	isRequired?: boolean
	requiresAction?: boolean
	files: ReactNode
}) {
	return (
		<DetailsCard title="Copy" requiresAction={requiresAction}>
			<TextArea
				label="Main copy / content"
				value={mainCopy}
				onChange={onChange}
				onCopy={onCopy}
				isRequired={isRequired}
			/>
			{files}
		</DetailsCard>
	)
}
